/**
 * Shared 401 handling – map API error codes to auth failure reasons.
 */

import { triggerAuthFailure } from '@utils/authFailureHandler';

type ErrorBody = {
  error?: { code?: string; message?: string };
};

/**
 * If the response is 401, trigger logout redirect and return true.
 */
export function handleApiUnauthorized(
  status: number,
  body: ErrorBody | null | undefined
): boolean {
  if (status !== 401) {
    return false;
  }
  const code = body?.error?.code;
  triggerAuthFailure(code === 'SESSION_REVOKED' ? 'session_revoked' : 'session_expired');
  return true;
}
